import React from "react";

export default function RegisterSubmitButton({ register }) {
  const isSubmitting = register.isSubmitting;
  const isDisabled =
    isSubmitting || Boolean(register.hasLocationValidationErrors);

  return (
    <button
      type="button"
      className={`register-submit-button${
        isSubmitting ? " register-submit-button--loading" : ""
      }`}
      onClick={register.handleRegister}
      disabled={isDisabled}
      aria-busy={isSubmitting}
    >
      <span className="register-submit-button__content">
        {isSubmitting ? (
          <span className="register-submit-spinner" aria-hidden="true" />
        ) : null}
        <span>
          {isSubmitting
            ? register.t("register_submit_loading", {
                defaultValue: "Creating account...",
              })
            : register.hasOptionalProfileDetails
            ? register.t("register_complete_optional_submit", {
                defaultValue: "Complete",
              })
            : register.t("register_skip_and_complete_submit", {
                defaultValue: "Skip and complete",
              })}
        </span>
      </span>
    </button>
  );
}
